var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 111"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5",
    fill: "current",
    cx: 22,
    cy: 22,
    r: 22
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59",
    d: "M25.22 15.23h1.88v-3.18a22.75 22.75 0 00-2.74-.14c-2.72 0-4.58 1.66-4.58 4.7v2.62h-3.07v3.56h3.07v9.12h3.68v-9.12h3.07l.47-3.56h-3.54V17c0-1.09.28-1.77 1.76-1.77z"
  }))))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NCA0NCI+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48ZyBpZD0iR3JvdXBfMTExIiBkYXRhLW5hbWU9Ikdyb3VwIDExMSI+PGNpcmNsZSBpZD0iRWxsaXBzZV81IiBkYXRhLW5hbWU9IkVsbGlwc2UgNSIgZmlsbD0iY3VycmVudCIgY3g9IjIyIiBjeT0iMjIiIHI9IjIyIi8+PHBhdGggaWQ9IlBhdGhfNTkiIGRhdGEtbmFtZT0iUGF0aCA1OSIgZD0iTTI1LjIyLDE1LjIzSDI3LjFWMTIuMDVhMjIuNzUsMjIuNzUsMCwwLDAtMi43NC0uMTRjLTIuNzIsMC00LjU4LDEuNjYtNC41OCw0Ljd2Mi42MkgxNi43MXYzLjU2aDMuMDd2OS4xMmgzLjY4VjIyLjc5aDMuMDdMMjcsMTkuMjNIMjMuNDZWMTdDMjMuNDYsMTUuOTEsMjMuNzQsMTUuMjMsMjUuMjIsMTUuMjNaIi8+PC9nPjwvZz48L2c+PC9zdmc+";
export { SvgFacebook as ReactComponent };